<template>
  <div class="container">
    <div class="row h-50">
      <div
        v-if="loading"
        class="row d-flex justify-content-center align-middle my-4"
      >
        <h3>Loading magical things :)</h3>
      </div>
      <div class="col-8 offset-2 my-4" v-else>
        <h2 class="message">Click Generate Crypto To Get Values</h2>
        <p>Use these values when you are obtaining an access token</p>
        <p>
          <label class="message" for="verifier">Verifier</label>
          <input
            class="form-control my-2"
            id="verifier"
            v-model="verifier"
            type="text"
            name="verifier"
          />
          <label class="message" for="challenge">Challenge</label>
          <input
            class="form-control my-2"
            id="challenge"
            v-model="challenge"
            type="text"
            name="challenge"
          />
        </p>
        <div class="py-3" style="text-align: center">
          <button class="ty-button" v-on:click="generateCrytpo">
            Generate Crypto
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";

export default {
  name: "frnativecrypto",
  data: function () {
    return {
      verifier: "",
      challenge: "",
      loading: false,
    };
  },
  methods: {
    base64URLEncode: function (words) {
      return CryptoJS.enc.Base64.stringify(words)
        .replace(/\+/g, "-")
        .replace(/\//g, "-")
        .replace(/=/g, "");
    },

    generateCrytpo: async function () {
      this.verifier = this.base64URLEncode(CryptoJS.lib.WordArray.random(50));
      this.challenge = this.base64URLEncode(CryptoJS.SHA256(this.verifier));
      console.log("verifier: ", verifier);
      console.log("challenge: ", challenge);
    },
  },
};
</script>

<style>
</style>